var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "120.000000pt",
    height: "120.000000pt",
    viewBox: "0 0 120.000000 120.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\n        Created by potrace 1.10, written by Peter Selinger 2001-2011\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,120.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543 1133 c-24 -9 -13 -30 17 -36 39 -8 90 2 90 18 0 20 -72 33 -107 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521 1057 c-23 -23 26 -76 70 -77 28 0 69 33 69 55 0 8 0 18 0 23 0 11 -127 11 -139 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976 1061 c-8 -12 4 -44 21 -54 7 -4 13 -17 13 -27 0 -10 5 -22 11 -25 15 -10 49 25 49 51 0 39 -77 83 -94 55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 1018 c-12 -6 -21 -16 -19 -22 5 -15 97 -20 110 -7 25 25 -50 49 -91 29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872 1018 c-35 -17 -21 -33 33 -36 61 -4 78 11 37 32 -36 18 -39 19 -70 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 940 c-10 -16 13 -47 46 -60 28 -12 36 -11 68 6 22 12 37 28 39 42 3 21 0 22 -72 22 -41 0 -78 -4 -81 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 933 c2 -12 12 -18 28 -18 16 0 26 6 28 18 3 13 -3 17 -28 17 -25 0 -31 -4 -28 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830 931 c0 -25 46 -61 77 -61 36 0 73 29 73 56 0 23 -3 24 -75 24 -67 0 -75 -2 -75 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 916 c-19 -14 -19 -15 -2 -21 22 -9 50 2 45 17 -6 18 -22 20 -43 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655 920 c-9 -15 4 -30 25 -30 27 0 34 17 11 29 -24 13 -28 14 -36 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 861 c-41 -11 -85 -42 -108 -77 -19 -29 -21 -48 -23 -168 0 -74 1 -139 4 -143 8 -14 78 -3 84 13 2 7 -9 31 -27 52 -29 37 -31 44 -28 108 l3 69 49 25 c48 24 58 35 70 73 8 25 50 19 54 -8 5 -26 41 -65 62 -65 8 0 26 -7 38 -16 19 -13 22 -24 22 -81 0 -56 -4 -71 -30 -110 -17 -24 -28 -48 -25 -53 7 -12 75 -18 82 -6 3 5 5 68 4 140 -3 145 -12 174 -74 220 -34 25 -113 39 -157 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 821 c4 -13 18 -16 19 -4 0 4 -5 9 -11 12 -7 2 -11 -2 -8 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 824 c-12 -12 4 -24 34 -24 19 0 29 5 29 15 0 15 -50 22 -63 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 815 c0 -12 8 -16 33 -13 17 2 32 8 32 13 0 6 -15 11 -32 13 -25 3 -33 -1 -33 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985 820 c-7 -12 2 -30 16 -30 5 0 9 9 9 20 0 21 -15 27 -25 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 800 c-8 -14 3 -30 21 -30 8 0 14 9 14 20 0 21 -24 28 -35 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 790 c0 -13 7 -20 20 -20 13 0 20 7 20 20 0 13 -7 20 -20 20 -13 0 -20 -7 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 752 c-15 -11 -19 -25 -19 -77 0 -35 4 -66 9 -69 4 -3 19 6 31 19 13 14 41 30 62 36 22 5 42 17 45 25 9 24 52 17 63 -11 15 -41 40 -32 40 15 0 34 -4 41 -32 54 -45 20 -174 26 -199 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 746 c-33 -14 -58 -56 -49 -81 9 -23 33 -18 46 10 13 30 48 33 65 6 6 -10 27 -21 46 -25 18 -3 44 -17 57 -31 31 -33 40 -32 40 4 0 40 -36 98 -71 116 -34 18 -94 19 -134 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 720 c-4 -6 -24 -19 -46 -30 -44 -23 -51 -53 -24 -107 23 -46 40 -55 95 -55 56 0 81 15 100 62 19 46 9 80 -29 101 -19 10 -39 23 -45 29 -13 13 -43 13 -51 0z m5 -112 c16 -10 24 -10 40 0 30 18 40 15 40 -13 0 -49 -102 -58 -119 -12 -14 37 3 47 39 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231 616 c-53 -14 -70 -41 -52 -84 7 -15 25 -36 42 -46 29 -17 30 -17 65 4 34 22 35 24 32 79 -3 64 -11 68 -87 47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867 623 c-4 -3 -7 -30 -7 -59 0 -43 4 -56 22 -68 34 -24 74 -20 103 11 47 51 29 96 -45 112 -60 13 -65 13 -73 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 446 l-23 -24 20 -25 c17 -22 27 -25 71 -24 40 2 55 7 70 26 19 23 19 23 -4 47 -31 33 -103 33 -134 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 434 c-16 -16 -5 -25 26 -22 17 2 31 8 30 13 -3 12 -46 19 -56 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 430 c-7 -12 34 -30 53 -22 7 2 11 10 9 16 -5 15 -53 20 -62 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 401 c-7 -11 18 -33 27 -24 4 3 7 12 7 20 0 15 -26 18 -34 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 373 c-30 -30 -37 -44 -39 -80 -4 -94 -5 -88 27 -88 28 0 30 2 33 45 4 50 16 70 42 70 25 0 30 -20 19 -69 -9 -39 2 -118 19 -145 4 -6 7 -20 7 -31 0 -17 7 -20 50 -20 l50 0 -3 80 c-4 81 -8 95 -81 233 -20 36 -28 42 -55 42 -24 0 -42 -10 -69 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 363 c-12 -27 -35 -68 -50 -93 -23 -38 -27 -58 -29 -130 l-2 -85 49 0 c42 0 49 3 50 20 0 11 3 27 7 35 19 46 27 103 18 135 -12 43 -4 75 19 75 26 0 38 -20 42 -70 3 -43 5 -45 33 -45 l30 0 -3 60 c-5 87 -48 144 -109 145 -28 0 -34 -5 -55 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977 404 c-9 -9 4 -34 18 -34 14 0 27 25 18 34 -4 3 -12 6 -18 6 -6 0 -14 -3 -18 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 357 c-24 -32 -31 -312 -9 -312 12 0 16 21 20 105 5 97 7 105 25 105 19 0 20 -6 18 -102 l-2 -103 54 0 55 0 0 69 c0 39 -4 72 -9 75 -8 5 -73 133 -84 169 -9 24 -49 21 -68 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043 363 c-11 -36 -76 -164 -84 -169 -5 -3 -9 -36 -9 -75 l0 -69 55 0 54 0 -6 93 c-5 79 -3 94 11 106 27 23 35 2 38 -104 2 -81 6 -100 18 -100 22 0 15 280 -9 312 -19 27 -59 30 -68 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 353 c-11 -11 -8 -20 9 -27 23 -9 37 3 23 20 -13 15 -22 18 -32 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895 341 c-3 -5 -1 -12 5 -16 12 -7 30 2 30 16 0 12 -27 12 -35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 311 c-8 -12 21 -34 34 -26 17 11 11 35 -9 35 -11 0 -22 -4 -25 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 275 c-4 -8 -3 -23 0 -32 6 -15 8 -15 23 -1 16 17 12 48 -7 48 -6 0 -13 -7 -16 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913 274 c-3 -8 1 -23 10 -32 15 -14 17 -14 23 1 8 21 -1 47 -16 47 -6 0 -13 -7 -17 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 120 c-1 -22 -2 -46 -3 -52 -1 -7 10 -13 24 -13 23 0 25 3 21 45 -4 52 -7 60 -27 60 -9 0 -14 -13 -15 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354 147 c-3 -8 -4 -34 -2 -58 3 -47 20 -59 51 -37 15 11 15 18 5 51 -13 42 -45 68 -54 44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 148 c-8 -11 -33 -74 -33 -84 0 -10 41 -23 55 -18 12 5 15 18 13 57 -3 51 -17 68 -35 45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875 138 c-2 -13 -6 -36 -7 -53 -3 -26 0 -30 22 -30 14 0 25 6 24 13 -1 6 -2 30 -2 52 -2 45 -28 57 -37 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreModules);
export default __webpack_public_path__ + "static/media/core-modules.3a37174416409ef0d87de48ea29b2312.svg";
export { ForwardRef as ReactComponent };